import HeroV2 from "@/components/landing/HeroV2";
import MedicationZone from "@/components/landing/MedicationZone";
import RealResults from "@/components/landing/RealResults";
import Footer from "@/components/landing/Footer";
import SEO, { orgSchema } from "@/components/shared/SEO";
import SpanishHint from "@/components/shared/SpanishHint";

// Conversion-focused homepage. Apple Store meets Amazon:
//   Hero → Medication Categories → Real Results → Assessment trigger.
// Everything secondary (FAQs, education) lives on dedicated pages.
export default function LandingPage() {
  return (
    <main className="bg-white text-black overflow-x-hidden min-h-screen">
      <SEO
        title="$39 First Week · Tirzepatide, Semaglutide & Peptides"
        path="/"
        description="BestRx.online — start for just $39 your first week. No insurance required. Tirzepatide, Semaglutide, B12, and peptide programs. Provider reviewed, delivered to your door."
        schema={orgSchema()}
      />
      <SpanishHint />
      <HeroV2 />
      <MedicationZone />
      <RealResults />
      <Footer />
    </main>
  );
}
